import { getAzureTtsData } from '@/services/tts/tts-data';
import { AudioError } from '@/state/presenters';
import { IVoice, TtsCredentials, VoiceConfig } from '@d-id/types';

/**
 * Get the text duration in seconds using the Azure SpeechSynthesizer
 * @param setInlineTtsError
 * @param token
 * @param text
 * @param voice
 * @param voiceConfig
 * @param languageToVoices
 * @returns The duration of the audio in seconds
 */

interface Params {
    setInlineTtsError: (ttsError: AudioError) => void;
    credentials?: TtsCredentials;
    text: string;
    voice: IVoice | null;
    voiceConfig?: VoiceConfig;
    languageToVoices: Record<string, IVoice[]>;
}

export const getTtsDuration = async (params: Params): Promise<number> => {
    const azureTtsData = await getAzureTtsData(params);
    return azureTtsData.duration;
};
